import React, { useState, useEffect } from "react";
import { StaffSideMenu } from "../../staff/StaffSideMenu";
import API_URL from "../../../api/API";
import { useStaffAuthContext } from "../../staff/useStaffAuthContext";
import { useParams, useNavigate } from "react-router-dom";
import SingleSelectExerciseList from "../../component/SingleSelectExerciseList";
import { DndContext, useDroppable, useDraggable } from "@dnd-kit/core";
import { arrayMove } from "@dnd-kit/sortable";
import { nanoid } from "nanoid";
import { GoArrowLeft } from "react-icons/go";
import {
  MdAdd,
  MdKeyboardArrowDown,
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdKeyboardArrowUp,
  MdOutlineKeyboardArrowRight,
} from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import { RxCross2 } from "react-icons/rx";
import { FiEdit2 } from "react-icons/fi";
import { RiDeleteBin4Line } from "react-icons/ri";
import { FaRegSave } from "react-icons/fa";

const DotedSvg = () => {
  return (
    <>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.99967 8.66732C6.36786 8.66732 6.66634 8.36884 6.66634 8.00065C6.66634 7.63246 6.36786 7.33398 5.99967 7.33398C5.63148 7.33398 5.33301 7.63246 5.33301 8.00065C5.33301 8.36884 5.63148 8.66732 5.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 3.99935C6.36786 3.99935 6.66634 3.70087 6.66634 3.33268C6.66634 2.96449 6.36786 2.66602 5.99967 2.66602C5.63148 2.66602 5.33301 2.96449 5.33301 3.33268C5.33301 3.70087 5.63148 3.99935 5.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.99967 13.3333C6.36786 13.3333 6.66634 13.0349 6.66634 12.6667C6.66634 12.2985 6.36786 12 5.99967 12C5.63148 12 5.33301 12.2985 5.33301 12.6667C5.33301 13.0349 5.63148 13.3333 5.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 8.66732C10.3679 8.66732 10.6663 8.36884 10.6663 8.00065C10.6663 7.63246 10.3679 7.33398 9.99967 7.33398C9.63148 7.33398 9.33301 7.63246 9.33301 8.00065C9.33301 8.36884 9.63148 8.66732 9.99967 8.66732Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 3.99935C10.3679 3.99935 10.6663 3.70087 10.6663 3.33268C10.6663 2.96449 10.3679 2.66602 9.99967 2.66602C9.63148 2.66602 9.33301 2.96449 9.33301 3.33268C9.33301 3.70087 9.63148 3.99935 9.99967 3.99935Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99967 13.3333C10.3679 13.3333 10.6663 13.0349 10.6663 12.6667C10.6663 12.2985 10.3679 12 9.99967 12C9.63148 12 9.33301 12.2985 9.33301 12.6667C9.33301 13.0349 9.63148 13.3333 9.99967 13.3333Z"
          stroke="#364153"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const AdminEditSpeedTrainingTemplate = () => {
  const { staff } = useStaffAuthContext();
  const { template_id } = useParams();
  const navigate = useNavigate();

  const [template, setTemplate] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [editStatus, setEditStatus] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  const [activeWeek, setActiveWeek] = useState(1);
  const [activeDay, setActiveDay] = useState("monday");
  const [weeksData, setWeeksData] = useState({}); // State to hold all week and day data

  const weeks = Array.from({ length: 24 }, (_, i) => i + 1);
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  //TRAINING FOCUS LETS LOAD ALL FROM THE MASTER
  const [trainingFocuses, setTrainingFocuses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(50);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [expandedId, setExpandedId] = useState(null);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [focusToApply, setFocusToApply] = useState(null);

  const [reorderMode, setReorderMode] = useState(false);
  const [openRows, setOpenRows] = useState({});

  const toggleRow = (index) => {
    setOpenRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Dropdown options
  const distances = [
    10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 133, 134, 150, 180, 200,
    220, 250, 300, 350, 400, 450,
  ];

  const intensities = [75, 80, 85, 88, 90, 92, 95, 98, 100];
  const rests = [
    "30s",
    "1m",
    "2m",
    "3m",
    "4m",
    "5m",
    "6m",
    "7m",
    "8m",
    "9m",
    "10m",
    "12m",
    "15m",
    "18m",
    "20",
    "25",
    "30m",
  ];
  const paces = [100, 200, 400];
  const range = (min, max) =>
    Array.from({ length: max - min + 1 }, (_, i) => i + min);

  const [showRestInput, setShowRestInput] = useState(false);
  const [restNoteInput, setRestNoteInput] = useState("");

  //training focus master data load here

  const [exerciseOptions, setExerciseOptions] = useState([]);
  const [resetTrigger, setResetTrigger] = useState(false);

  // Fetch exercise options
  useEffect(() => {
    const fetchExercises = async () => {
      try {
        const res = await fetch(`${API_URL.GET_EXERCISE_LIBRARY_LIST_ADMIN}`, {
          headers: {
            Authorization: `Bearer ${staff?.token}`,
          },
        });
        const data = await res.json();
        if (res.ok && data?.exercises) {
          setExerciseOptions(data.exercises);

          //  console.log("Exer Options");
        }
      } catch (err) {
        console.error("Error loading exercises:", err);
      }
    };

    fetchExercises();
  }, [staff?.token]);

  useEffect(() => {
    const fetchTrainingFocuses = async () => {
      setIsLoading(true);
      try {
        const res = await fetch(
          API_URL.ADMIN_SPEED_TEMPLATE_TRAINING_FOCUS_MANAGE,
          {
            headers: {
              Authorization: `Bearer ${staff.token}`,
            },
          },
        );
        const data = await res.json();
        setTrainingFocuses(data.data || []);
        setTotalPages(Math.ceil((data.data || []).length / itemsPerPage));
      } catch (err) {
        setError("Failed to load training focus data.");
      } finally {
        setIsLoading(false);
      }
    };

    if (staff?.token) fetchTrainingFocuses();
  }, [staff.token, currentPage, itemsPerPage]);

  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  };

  const filteredTrainingFocuses = trainingFocuses.filter((item) => {
    const focus = item.training_focus?.toLowerCase() || "";
    const phase = item.training_phase?.toLowerCase() || "";
    return (
      focus.includes(searchQuery.toLowerCase()) ||
      phase.includes(searchQuery.toLowerCase())
    );
  });

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  const fetchTemplate = async () => {
    try {
      const res = await fetch(
        `${API_URL.ADMIN_GET_SPEED_TRAINING_TEMPLATE}${template_id}`,
        {
          headers: {
            Authorization: `Bearer ${staff?.token}`,
          },
        },
      );

      const data = await res.json();

      if (res.ok) {
        const { title, status, weeks } = data.data;
        setTemplate(data.data);
        setEditTitle(title);
        setEditStatus(status);

        const formattedWeeksData = {};

        weeks.forEach((week) => {
          const { weekNumber, _id, days } = week;

          // Ensure each day's sprints default to [] if missing
          const formattedDays = {};
          Object.entries(days).forEach(([dayName, dayValue]) => {
            formattedDays[dayName.toLowerCase()] = {
              sprints: dayValue.sprints || [],
              training_focus: dayValue.training_focus || "",
              training_phase: dayValue.training_phase || "",
              _id: dayValue._id || null,
            };
          });

          formattedWeeksData[weekNumber] = {
            weekNumber,
            _id,
            days: formattedDays,
          };
        });

        setWeeksData(formattedWeeksData);
      } else {
        console.error("Failed to fetch template:", data.message);
      }
    } catch (error) {
      console.error("Error fetching template:", error);
    } finally {
      setLoading(false);
    }
  };

  //fetch all of the template data
  useEffect(() => {
    fetchTemplate();
  }, [template_id, staff]);

  //save the template title and status
  const handleSave = async () => {
    setSaving(true);
    try {
      const res = await fetch(
        `${API_URL.ADMIN_UPDATE_SPEED_TRAINING_TEMPLATE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({ title: editTitle, status: editStatus }),
        },
      );
      const data = await res.json();
      if (res.ok) {
        setTemplate(data.data);
        setIsEditing(false);
        alert("Template updated successfully");
      } else {
        alert(data.message || "Failed to update");
      }
    } catch (error) {
      console.error("Error updating template:", error);
      alert("Error saving template");
    } finally {
      setSaving(false);
    }
  };

  // Get the selected week and day data
  const selectedWeekData = weeksData[activeWeek] || {};
  const selectedDayData = weeksData?.[activeWeek]?.days?.[activeDay] || {};

  //copy the data from the training focus into the specific day that is selected
  const applyFocusToDay = (focus) => {
    setWeeksData((prev) => {
      const updated = { ...prev };

      // Ensure activeWeek exists
      if (!updated[activeWeek]) {
        updated[activeWeek] = {
          weekNumber: String(activeWeek),
          days: {},
        };
      }

      // Ensure days object exists
      if (!updated[activeWeek].days) {
        updated[activeWeek].days = {};
      }

      // Copy the data into the selected day
      updated[activeWeek].days[activeDay] = {
        training_focus: focus.training_focus || "",
        training_phase: focus.training_phase || "",
        sprints: (focus.sprints || []).map((sprint, index) => ({
          exercise_id: sprint.exercise_id?._id || sprint.exercise_id,
          order_id: index + 1,
          sets: sprint.sets || 0,
          reps: sprint.reps || 0,
          distance: sprint.distance || 0,
          pace: sprint.pace || 0,
          intensity: sprint.intensity || 0,
          rest: sprint.rest || "",
          notes: sprint.notes || "",
          target_time: sprint.target_time || 0,
          type: sprint.type || "Sprint",
          rest_duration: sprint.rest_duration || "",
          rest_notes: sprint.rest_notes || "",
        })),
      };

      return updated;
    });
  };

  //handle the sprint data changes for any day.
  const handleSprintChange = (index, field, value) => {
    setWeeksData((prev) => {
      const updated = { ...prev };
      const sprint = updated[activeWeek].days[activeDay].sprints[index];

      if (
        field === "sets" ||
        field === "reps" ||
        field === "distance" ||
        field === "pace" ||
        field === "intensity" ||
        field === "target_time"
      ) {
        sprint[field] = parseInt(value) || 0;
      } else {
        sprint[field] = value;
      }

      return updated;
    });
  };
  //delete a sprint row for any day
  const deleteSprintRow = (indexToRemove) => {
    setWeeksData((prev) => {
      const updated = structuredClone(prev); // or deep copy another way
      const day = updated[activeWeek]?.days?.[activeDay];

      if (!day || !day.sprints) return prev;

      const filtered = day.sprints.filter((_, i) => i !== indexToRemove);

      // Reassign order_ids
      updated[activeWeek].days[activeDay].sprints = filtered.map(
        (sprint, idx) => ({
          ...sprint,
          order_id: idx + 1,
        }),
      );

      return updated;
    });
  };

  //add a new sprint row for a day inside week - day
  const addSprintRow = (weekKey, dayKey) => {
    setWeeksData((prev) => {
      const newWeeksData = structuredClone(prev); // or deep copy manually if needed

      if (!newWeeksData[weekKey]) {
        newWeeksData[weekKey] = { weekNumber: weekKey, days: {} };
      }

      if (!newWeeksData[weekKey].days[dayKey]) {
        newWeeksData[weekKey].days[dayKey] = { sprints: [] };
      }

      const sprints = newWeeksData[weekKey].days[dayKey].sprints || [];

      newWeeksData[weekKey].days[dayKey].sprints = [
        ...sprints,
        {
          type: "Sprint",
          sets: 1,
          reps: 1,
          distance: 10,
          pace: 100,
          intensity: 75,
          rest: "",
          notes: "",
          target_time: 0,
          rest_duration: "",
          rest_notes: "",
          order_id: sprints.length + 1,
          exercise_id: null,
        },
      ];

      return newWeeksData;
    });

    // await handleSaveTemplate();
  };

  //add rest data for Week-Day sprint row
  const addRestRow = (weekKey, dayKey, restNotes = "") => {
    setWeeksData((prev) => {
      const newWeeksData = structuredClone(prev); // deep copy

      if (!newWeeksData[weekKey]) {
        newWeeksData[weekKey] = { weekNumber: weekKey, days: {} };
      }

      if (!newWeeksData[weekKey].days[dayKey]) {
        newWeeksData[weekKey].days[dayKey] = { sprints: [] };
      }

      const sprints = newWeeksData[weekKey].days[dayKey].sprints || [];

      const newRestRow = {
        type: "Rest",
        order_id: sprints.length + 1,
        sets: 0, // Required by backend
        reps: 0, // Required by backend
        rest_duration: "",
        rest_notes: restNotes,
      };

      newWeeksData[weekKey].days[dayKey].sprints = [...sprints, newRestRow];

      return newWeeksData;
    });

    //await handleSaveTemplate();
  };

  // Function to convert the structure to the proper format
  const convertToProperFormat = (inputData) => {
    const weekKeys = Object.keys(inputData);
    const allDaysOfWeek = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ];

    const transformedWeeks = weekKeys.map((weekKey) => {
      const week = inputData[weekKey];
      const weekData = week.days || week; // Use nested 'days' if available

      const transformedWeek = {
        weekNumber: weekKey, // Use the key as the week number
        days: {},
      };

      allDaysOfWeek.forEach((day) => {
        transformedWeek.days[day] = weekData[day] || { sprints: [] };
      });

      return transformedWeek;
    });

    return transformedWeeks;
  };

  //save the template
  const handleSaveTemplate = async () => {
    // Convert to the proper format before sending
    const formattedData = convertToProperFormat(weeksData);

    // console.log('Formatted Data:', formattedData);  // Log the formatted data for debugging

    try {
      const response = await fetch(
        `${API_URL.ADMIN_SAVE_SPEED_TRAINING_TEMPLATE}${template_id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${staff?.token}`,
          },
          body: JSON.stringify({
            weeksData: formattedData, // Send the data as a key inside an object
          }),
        },
      );

      if (!response.ok) {
        throw new Error("Failed to save template");
      }
      fetchTemplate();
      // Handle success
      alert("Template saved successfully!");
    } catch (error) {
      // Handle error and provide feedback to the user
      alert("Error saving template: " + error.message);
    }
  };

  const handleSprintDragEnd = (event, weekKey, dayKey) => {
    const { active, over } = event;

    if (!over || active.id === over.id) return;

    setWeeksData((prev) => {
      const newWeeksData = structuredClone(prev);
      const sprints = newWeeksData[weekKey]?.days?.[dayKey]?.sprints || [];

      // Fallback to temp IDs for unsaved sprints
      const getSprintId = (s, index) => s._id || `temp-${index}`;

      // Map sprint list to use consistent ids
      const sprintIds = sprints.map(getSprintId);

      const oldIndex = sprintIds.findIndex((id) => id === active.id);
      const newIndex = sprintIds.findIndex((id) => id === over.id);

      if (oldIndex === -1 || newIndex === -1) return prev;

      const [moved] = sprints.splice(oldIndex, 1);
      sprints.splice(newIndex, 0, moved);

      // Reassign order_id
      newWeeksData[weekKey].days[dayKey].sprints = sprints.map((s, i) => ({
        ...s,
        order_id: i + 1,
      }));

      return newWeeksData;
    });
  };

  const getWeekTotalDistance = (weekKey) => {
    const days = weeksData[weekKey]?.days || {};

    return Object.values(days).reduce((weekTotal, day) => {
      const sprints = day?.sprints || [];

      const dayTotal = sprints.reduce((sum, sprint) => {
        if (sprint.type === "Rest") return sum;

        const sets = parseFloat(sprint.sets) || 0;
        const reps = parseFloat(sprint.reps) || 0;
        const distance = parseFloat(sprint.distance) || 0;

        return sum + sets * reps * distance;
      }, 0);

      return weekTotal + dayTotal;
    }, 0);
  };

  return (
    <div className="flex md:h-screen font-inter">
      <StaffSideMenu />
      <div className="md:flex-1 w-full bg-bgBase relative flex max-md:flex-col">
        {/* Week Tabs */}
        <div className="max-md:p-5 md:w-44 flex-none md:overflow-y-auto show-scrollbar inline-block bg-white border-r border-tblBorder">
          <div className="p-2 md:p-6 border-b border-tblBorder">
            <p className="text-dark text-xl font-medium capitalize max-md:ml-12">
              weeks
            </p>
          </div>

          {/* weeks */}
          <div className="flex max-md:flex-wrap md:flex-col">
            {weeks.map((week) => {
              const totalDistance = getWeekTotalDistance(week);

              return (
                <button
                  key={week}
                  onClick={() => setActiveWeek(week)}
                  className={`p-2 md:px-5 md:py-4 text-start text-sm font-medium max-md:border-b-2 md:border-l-4 tracking-tighter ${
                    activeWeek === week
                      ? "bg-[#F3F4F6] text-dark border-dark"
                      : "bg-white text-slate100 border-transparent"
                  }`}
                >
                  Week {week}
                  {totalDistance > 0 && (
                    <span className="ml-0.5">, {totalDistance}m</span>
                  )}
                </button>
              );
            })}
          </div>
        </div>
        {/* right side */}
        <div className="w-full overflow-auto inline-flex flex-col">
          <div className="bg-white md:sticky md:top-0 md:z-10">
            {/* Button Container */}
            <div className="w-full max-w-[1400px] space-y-5 py-3 md:py-5 px-5 md:px-8 border-t border-tblBorder">
              <div className="flex max-lg:flex-col justify-between gap-5">
                <button
                  onClick={() => navigate(-1)}
                  className="text-slate100 font-inter font-normal text-sm leading-tight flex items-center gap-2 hover:underline"
                >
                  <MdKeyboardArrowLeft color="#666666" size={20} /> Go Back
                </button>

                <div className="flex max-sm:flex-col flex-wrap gap-2">
                  <div className="flex gap-2 pr-2 sm:border-r border-tblBorder">
                    <select
                      value={editStatus}
                      onChange={(e) => setEditStatus(e.target.value)}
                      className="w-full border border-tblBorder p-2.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                    >
                      <option value="DRAFT">DRAFT</option>
                      <option value="PUBLISHED">PUBLISHED</option>
                    </select>

                    {isEditing ? (
                      <>
                        <button
                          onClick={handleSave}
                          disabled={saving}
                          className="p-2 rounded-lg hover:bg-gray-200"
                        >
                          <FaRegSave color="#666666" size={16} />
                        </button>
                        <button
                          onClick={() => setIsEditing(false)}
                          className="p-2 rounded-lg hover:bg-gray-200"
                        >
                          <RxCross2 color="#666666" size={16} />
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          onClick={() => setIsEditing(true)}
                          className="p-2 rounded-lg hover:bg-gray-200"
                        >
                          <FiEdit2 color="#666666" size={16} />
                        </button>
                      </>
                    )}
                  </div>
                  <button
                    onClick={handleSaveTemplate}
                    className="px-6 py-2.5 h-fit bg-dark text-white font-inter font-normal text-sm rounded-lg hover:bg-black"
                  >
                    Save Template
                  </button>
                </div>
              </div>

              {/* Top bar */}
              <div className="flex items-center gap-4">
                {loading ? (
                  <div className="text-slate100 text-sm">
                    Loading template details...
                  </div>
                ) : !isEditing ? (
                  <>
                    <div className="flex items-start gap-5">
                      <div className="flex flex-col gap-1">
                        <div>
                          <span className="text-dark font-medium text-xl">
                            {template.title}
                          </span>
                        </div>
                        {/* <div>
                          <span className="text-dark font-medium">
                            {template.status}
                          </span>
                        </div> */}
                      </div>
                      <button
                        onClick={() => setIsEditing(true)}
                        className="p-2 rounded-lg hover:bg-gray-200"
                      >
                        <FiEdit2 color="#666666" size={16} />
                      </button>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="w-full max-w-md flex flex-col gap-2">
                      <input
                        type="text"
                        value={editTitle}
                        onChange={(e) => setEditTitle(e.target.value)}
                        className="w-full border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight"
                      />
                      {/* <select
                        value={editStatus}
                        onChange={(e) => setEditStatus(e.target.value)}
                        className="w-full mt-2 border border-tblBorder p-3 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-tight outline-none"
                      >
                        <option value="DRAFT">DRAFT</option>
                        <option value="PUBLISHED">PUBLISHED</option>
                      </select> */}
                      <div className="flex gap-2">
                        <button
                          onClick={handleSave}
                          disabled={saving}
                          className="bg-dark border border-tblBorder rounded-10 py-2.5 px-5 text-white font-inter font-medium text-sm leading-tight capitalize hover:bg-black transition"
                        >
                          {saving ? "Saving..." : "Save"}
                        </button>
                        <button
                          onClick={() => setIsEditing(false)}
                          className="bg-transparent border border-tblBorder rounded-10 py-2.5 px-5 text-dark font-inter font-medium text-sm leading-tight capitalize hover:bg-dark hover:text-white transition"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Display selected day data */}
            <div className="w-full max-w-[1400px] py-4 xl:py-6 px-5 md:px-8 border-t border-tblBorder">
              <h2 className="text-dark text-lg lg:text-2xl font-medium capitalize mb-4">
                Week {activeWeek}
                {/* {activeDay.charAt(0).toUpperCase() + activeDay.slice(1)} */}
              </h2>

              {/* Days Tabs */}
              <div className="inline-flex flex-wrap gap-y-2 gap-x-3">
                {days.map((day) => {
                  const focus =
                    weeksData[activeWeek]?.days?.[day]?.training_focus;
                  const isActive = activeDay === day;

                  //total distance for the day
                  const sprints =
                    weeksData[activeWeek]?.days?.[day]?.sprints || [];
                  const totalDistance = sprints.reduce((total, sprint) => {
                    if (sprint.type === "Rest") return total;

                    const sets = parseFloat(sprint.sets) || 0;
                    const reps = parseFloat(sprint.reps) || 0;
                    const distance = parseFloat(sprint.distance) || 0;

                    return total + sets * reps * distance;
                  }, 0);

                  return (
                    <>
                      <div>
                        <button
                          key={day}
                          onClick={() => setActiveDay(day)}
                          className={`w-full px-3 py-2 lg:px-6 lg:py-3 text-sm font-medium leading-none rounded-md lg:rounded-xl capitalize border ${
                            isActive
                              ? "text-white bg-dark"
                              : "bg-white text-dark hover:bg-gray-100"
                          }`}
                        >
                          {day}
                        </button>
                        {focus && (
                          <p
                            className={`block text-center text-xs font-medium ${isActive ? "text-dark" : "text-slate100"} pt-1.5`}
                          >
                            ({focus})/
                            {totalDistance > 0 && ` - ${totalDistance}m`}
                          </p>
                        )}
                      </div>
                    </>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Sprint Configurations */}
          <div className="w-full max-w-[1400px] py-4 px-5 md:px-6">
            {selectedDayData.sprints && selectedDayData.sprints.length > 0 ? (
              reorderMode ? (
                <div className="space-y-4">
                  <div className="flex max-sm:flex-col justify-between gap-2 sm:gap-5">
                    <h3 className="text-dark text-lg font-medium">
                      Reorder Sprints
                    </h3>

                    <button
                      onClick={() => setReorderMode(!reorderMode)}
                      className={`w-fit px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl`}
                    >
                      {reorderMode ? "Back to Editor" : "Reorder Sprints"}
                    </button>
                  </div>

                  <DndContext
                    onDragEnd={(event) =>
                      handleSprintDragEnd(event, activeWeek, activeDay)
                    }
                  >
                    {selectedDayData.sprints.map((sprint, index) => {
                      const sprintId = sprint._id || `temp-${index}`;

                      return (
                        <DroppableSprint key={sprintId} id={sprintId}>
                          <DraggableSprintItem
                            key={sprintId}
                            id={sprintId}
                            sprintIndex={index}
                            sprint={sprint}
                          />
                        </DroppableSprint>
                      );
                    })}
                  </DndContext>
                </div>
              ) : (
                <>
                  {/* Buttons only shown if sprint data exists */}
                  <div className="flex flex-col space-y-4 mb-4">
                    <h2 className="text-lg font-semibold">
                      Sprint Configurations
                    </h2>
                    {/* Display training focus and training phase */}
                    <div className="space-y-4">
                      {/* Sprint Configurations */}
                      <div className="flex flex-wrap justify-between gap-4">
                        <div>
                          <h3 className="font-normal text-slate100">
                            Training Focus:
                          </h3>
                          <p className="text-sm font-medium text-dark">
                            {selectedDayData.training_focus || "No focus set"}
                          </p>
                        </div>
                        <div>
                          <h3 className="font-normal text-slate100">
                            Training Phase:
                          </h3>
                          <p className="text-sm font-medium text-dark">
                            {selectedDayData.training_phase || "No phase set"}
                          </p>
                        </div>
                      </div>
                      {/* Total Distance - Action Buttons */}
                      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-2 lg:gap-4">
                        {/* Right: Total Distance */}
                        {selectedDayData.sprints?.length > 0 && (
                          <p className="font-medium text-sm text-slate100">
                            Total:{" "}
                            {selectedDayData.sprints.reduce((total, sprint) => {
                              if (sprint.type === "Rest") return total;
                              const sets = parseFloat(sprint.sets) || 0;
                              const reps = parseFloat(sprint.reps) || 0;
                              const distance = parseFloat(sprint.distance) || 0;
                              return total + sets * reps * distance;
                            }, 0)}{" "}
                            meters
                          </p>
                        )}
                        {/* Left: Action Buttons */}
                        <div className="flex flex-wrap items-center gap-2">
                          <button
                            onClick={() => addSprintRow(activeWeek, activeDay)}
                            className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                          >
                            <MdAdd color="#000" /> Add Sprint
                          </button>

                          {showRestInput ? (
                            <></>
                          ) : (
                            <button
                              onClick={() => setShowRestInput(true)}
                              className="px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl"
                            >
                              <MdAdd color="#000" /> Add Rest
                            </button>
                          )}

                          <button
                            onClick={() => setReorderMode(!reorderMode)}
                            className={`px-4 py-2.5 flex items-center gap-2 bg-white hover:bg-tblHead border border-tblBorder text-dark text-sm font-medium rounded-xl`}
                          >
                            {reorderMode ? (
                              "Back to Editor"
                            ) : (
                              <>
                                <DotedSvg /> Reorder Sprints
                              </>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                    {/* rest form */}
                    {showRestInput && (
                      <div className="bg-white border border-tblBorder rounded-10 p-4 my-4">
                        <div className="mb-3">
                          <label className="block text-dark text-sm font-medium mb-1">
                            Rest Notes
                          </label>
                          <input
                            type="text"
                            placeholder="Enter rest notes"
                            value={restNoteInput}
                            onChange={(e) => setRestNoteInput(e.target.value)}
                            className="w-full border border-tblBorder px-3 py-2 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-snug outline-none"
                          />
                        </div>
                        <div className="flex flex-wrap gap-1 sm:gap-3">
                          <button
                            onClick={() => {
                              addRestRow(activeWeek, activeDay, restNoteInput);
                              setRestNoteInput("");
                              setShowRestInput(false);
                            }}
                            className="px-6 py-2.5 bg-dark text-white font-inter font-normal text-sm leading-none rounded-lg hover:bg-black"
                          >
                            Save
                          </button>
                          <button
                            onClick={() => {
                              setRestNoteInput("");
                              setShowRestInput(false);
                            }}
                            className="px-6 py-2.5 bg-white border border-tblBorder text-dark font-inter font-normal text-sm leading-none rounded-lg hover:bg-black hover:text-white"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Render Sprint and Rest Rows */}
                  {selectedDayData.sprints.map((sprint, index) => {
                    const selectedExercise = exerciseOptions.find(
                      (exercise) =>
                        exercise._id ===
                        (sprint.exercise_id &&
                        typeof sprint.exercise_id === "object"
                          ? sprint.exercise_id._id
                          : sprint.exercise_id),
                    );

                    const extractYouTubeId = (url) => {
                      if (!url) return null;

                      const regex =
                      /(?:youtu\.be\/|youtube(?:-nocookie)?\.com\/(?:shorts\/|watch\?.*?v=|embed\/|v\/))([\w-]{11})/;
                  
                      const match = url.match(regex);
                      return match ? match[1] : null;
                    };

                    const extractYouTubeThumbnail = (url) => {
                      const id = extractYouTubeId(url);
                      return id
                        ? `https://img.youtube.com/vi/${id}/hqdefault.jpg`
                        : null;
                    };

                    const thumbnail = selectedExercise?.video_url
                      ? extractYouTubeThumbnail(selectedExercise.video_url)
                      : null;
                    return (
                      <>
                        {sprint.type === "Rest" ? (
                          <div
                            key={sprint._id}
                            className="w-full bg-[#E1E1E1] py-2.5 px-3 rounded-10 text-dark font-normal text-sm flex justify-between items-center gap-5 mb-4"
                          >
                            <div className="text-sm text-gray-700">
                              Rest Notes: {sprint.rest_notes || "None"}
                            </div>
                            <div className="flex-none">
                              <button
                                onClick={() => deleteSprintRow(index)}
                                className="p-2 rounded-md hover:bg-gray-200"
                              >
                                <RiDeleteBin4Line color="#666666" size={20} />
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            key={sprint._id}
                            className="mb-4 border border-tblBorder rounded-10 bg-[#F9FAFB]"
                          >
                            {/* Exercise */}
                            {openRows[sprint._id] && (
                              <div className={`${openRows[sprint._id] ? "border-b" : ""}  border-tblBorder`}>
                                <div className="flex justify-between items-end gap-2 md:gap-5 p-4">
                                  <SingleSelectExerciseList
                                    value={
                                      sprint.exercise_id
                                        ? typeof sprint.exercise_id === "object"
                                          ? sprint.exercise_id._id
                                          : sprint.exercise_id
                                        : null
                                    }
                                    onChange={(val) =>
                                      handleSprintChange(
                                        index,
                                        "exercise_id",
                                        val,
                                      )
                                    }
                                    exercises={exerciseOptions}
                                    resetTrigger={resetTrigger}
                                  />

                                  <div className="flex-none">
                                    <button
                                      onClick={() => deleteSprintRow(index)}
                                      className="p-2 rounded-md hover:bg-gray-200"
                                    >
                                      <RiDeleteBin4Line
                                        color="#666666"
                                        size={20}
                                      />
                                    </button>
                                    <button
                                      onClick={() => toggleRow(sprint._id)}
                                      className="p-2 rounded hover:bg-gray-200"
                                    >
                                      {openRows[sprint._id] ? (
                                        <MdKeyboardArrowUp
                                          color="#6A7282"
                                          size={20}
                                        />
                                      ) : (
                                        <MdKeyboardArrowDown
                                          color="#6A7282"
                                          size={20}
                                        />
                                      )}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                            {/* Notes */}
                            {/* Sets / Reps / Distance .... */}
                            <div className="flex flex-wrap gap-3 p-4">
                              <div className="flex-none">
                                <div className="w-12 h-12 lg:w-16 lg:h-16 shrink-0">
                                  {openRows[sprint._id] ||
                                    (sprint.exercise_id && (
                                      <>
                                        <img
                                          src={thumbnail}
                                          alt={
                                            selectedExercise?.title ||
                                            "Exercise Thumbnail"
                                          }
                                          className="w-12 h-12 object-cover rounded-md border border-tblBorder"
                                        />
                                      </>
                                    ))}
                                </div>
                              </div>
                              <div className="flex-1 flex flex-wrap gap-3">
                                {/* Sets */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Sets
                                  </label>
                                  <select
                                    value={sprint.sets}
                                    onChange={(e) =>
                                      handleSprintChange(
                                        index,
                                        "sets",
                                        e.target.value,
                                      )
                                    }
                                    className="w-full mt-1 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {range(1, 15).map((num) => (
                                      <option key={num} value={num}>
                                        {num}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {/* Reps */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Reps
                                  </label>
                                  <select
                                    value={sprint.reps}
                                    onChange={(e) =>
                                      handleSprintChange(
                                        index,
                                        "reps",
                                        e.target.value,
                                      )
                                    }
                                    className="w-full mt-1 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {range(1, 15).map((num) => (
                                      <option key={num} value={num}>
                                        {num}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {/* Distance */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Distance (m)
                                  </label>
                                  <select
                                    value={sprint.distance}
                                    onChange={(e) =>
                                      handleSprintChange(
                                        index,
                                        "distance",
                                        e.target.value,
                                      )
                                    }
                                    className="w-full mt-1 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {distances.map((d) => (
                                      <option key={d} value={d}>
                                        {d}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {/* Pace */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Pace
                                  </label>
                                  <select
                                    value={sprint.pace}
                                    onChange={(e) =>
                                      handleSprintChange(
                                        index,
                                        "pace",
                                        e.target.value,
                                      )
                                    }
                                    className="w-full mt-1 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {paces.map((p) => (
                                      <option key={p} value={p}>
                                        {p}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {/* Intensity */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Intensity (%)
                                  </label>
                                  <select
                                    value={sprint.intensity}
                                    onChange={(e) =>
                                      handleSprintChange(
                                        index,
                                        "intensity",
                                        e.target.value,
                                      )
                                    }
                                    className="w-full mt-1 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                  >
                                    {intensities.map((i) => (
                                      <option key={i} value={i}>
                                        {i}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                {/* Rest */}
                                <div className="flex-1 min-w-20">
                                  <label className="block text-slate100 text-xs font-normal">
                                    Rest
                                  </label>
                                  <input
                                    type="text"
                                    value={sprint.rest}
                                    onChange={(e) =>
                                      handleSprintChange(
                                        index,
                                        "rest",
                                        e.target.value,
                                      )
                                    }
                                    className="w-full mt-1 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-none outline-none"
                                    placeholder="Enter rest duration"
                                  />
                                </div>
                              </div>
                              <div className="flex-none flex items-start lg:items-center">
                                {openRows[sprint._id] ? (
                                  <div className="opacity-0">
                                    <button
                                      onClick={() => deleteSprintRow(index)}
                                      className="p-2 rounded-md hover:bg-gray-200"
                                    >
                                      <RiDeleteBin4Line
                                        color="#666666"
                                        size={20}
                                      />
                                    </button>
                                    <button
                                      onClick={() => toggleRow(sprint._id)}
                                      className="p-2 rounded hover:bg-gray-200"
                                    >
                                      {openRows[sprint._id] ? (
                                        <MdKeyboardArrowUp
                                          color="#6A7282"
                                          size={20}
                                        />
                                      ) : (
                                        <MdKeyboardArrowDown
                                          color="#6A7282"
                                          size={20}
                                        />
                                      )}
                                    </button>
                                  </div>
                                ) : (
                                  <>
                                    <button
                                      onClick={() => deleteSprintRow(index)}
                                      className="p-2 rounded-md hover:bg-gray-200"
                                    >
                                      <RiDeleteBin4Line
                                        color="#666666"
                                        size={20}
                                      />
                                    </button>
                                    <button
                                      onClick={() => toggleRow(sprint._id)}
                                      className="p-2 rounded hover:bg-gray-200"
                                    >
                                      {openRows[sprint._id] ? (
                                        <MdKeyboardArrowUp
                                          color="#6A7282"
                                          size={20}
                                        />
                                      ) : (
                                        <MdKeyboardArrowDown
                                          color="#6A7282"
                                          size={20}
                                        />
                                      )}
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                            {openRows[sprint._id] && (
                              <>
                                <div className="bg-[#FBFCFC] rounded-b-10 text-slate100 font-normal text-xs flex flex-wrap gap-3 p-4 border-t border-tblBorder">
                                  <div className="flex-none max-sm:hidden">
                                    <div className="w-12 h-12 lg:w-16 lg:h-16 shrink-0"></div>
                                  </div>
                                  <div className="flex-1 ">
                                    <label className="block text-slate100 text-xs font-normal">
                                      Notes
                                    </label>
                                    <textarea
                                      value={sprint.notes || ""}
                                      onChange={(e) =>
                                        handleSprintChange(
                                          index,
                                          "notes",
                                          e.target.value,
                                        )
                                      }
                                      className="w-full mt-2 border border-tblBorder px-2 py-1.5 rounded-10 placeholder:text-slate100 text-sm font-inter font-normal leading-snug outline-none"
                                      rows={2}
                                    />
                                  </div>
                                  <div className="flex-none max-sm:hidden">
                                    <div className="w-[72px]"></div>
                                  </div>
                                </div>
                              </>
                            )}
                          </div>
                        )}
                      </>
                    );
                  })}
                </>
              )
            ) : (
              <div className="h-full overflow-auto">
                <div className="relative w-full min-w-64 max-w-64">
                  <input
                    type="text"
                    value={searchQuery}
                    onChange={handleSearch}
                    placeholder="Search training focus..."
                    className="w-full p-3 border border-black/10 rounded-lg font-inter font-normal text-sm leading-none pl-10"
                  />
                  <span className="absolute top-1/2 -translate-y-1/2 left-3">
                    <CiSearch color="#666666" size={20} />
                  </span>
                </div>
                <div className="rounded-10 border border-tblBorder md:max-h-[500px] overflow-auto show-scrollbar mt-4 mb-5">
                  <table className="table-auto table-radius bg-white rounded-10 w-full">
                    {/* <thead className="sticky top-0 bg-gray-200">
                            <tr>
                              <th className="px-6 py-3 text-left border-b border-gray-300">
                                Training Focus
                              </th>
                              <th className="px-6 py-3 text-left border-b border-gray-300">
                                Training Phase
                              </th>
                              <th className="px-6 py-3 text-left border-b border-gray-300">
                                Total Distance
                              </th>

                              <th className="px-6 py-3 text-left border-b border-gray-300">
                                Actions
                              </th>
                            </tr>
                          </thead> */}
                    <tbody>
                      {filteredTrainingFocuses
                        .slice(
                          (currentPage - 1) * itemsPerPage,
                          currentPage * itemsPerPage,
                        )
                        .map((item, index) => (
                          <React.Fragment key={item._id}>
                            <tr key={item._id}>
                              <td className="p-4">
                                <div className="flex flex-col justify-between gap-x-5 gap-y-1">
                                  <p className="block text-dark text-sm font-medium leading-tight">
                                    {" "}
                                    {item.training_focus}
                                  </p>
                                  <p className="block text-slate100 text-xs font-medium leading-tight">
                                    {" "}
                                    {item.training_phase}
                                  </p>
                                </div>
                              </td>
                              {/* Calculate total distance / arraow btn */}
                              <td className="p-4">
                                <div className="flex justify-end items-center gap-3">
                                  {item.sprints?.length > 0 && (
                                    <p className="text-slate100 text-sm leading-tight font-medium">
                                      {item.sprints.reduce((total, sprint) => {
                                        if (sprint.type === "Rest")
                                          return total;

                                        const sets =
                                          parseFloat(sprint.sets) || 0;
                                        const reps =
                                          parseFloat(sprint.reps) || 0;
                                        const distance =
                                          parseFloat(sprint.distance) || 0;

                                        return total + sets * reps * distance;
                                      }, 0)}
                                      m
                                    </p>
                                  )}

                                  <button
                                    onClick={() =>
                                      setExpandedId(
                                        expandedId === item._id
                                          ? null
                                          : item._id,
                                      )
                                    }
                                    className="p-2 rounded hover:bg-gray-200"
                                  >
                                    {expandedId === item._id ? (
                                      <>
                                        <MdKeyboardArrowUp
                                          color="#6A7282"
                                          size={20}
                                        />
                                      </>
                                    ) : (
                                      <>
                                        <MdKeyboardArrowDown
                                          color="#6A7282"
                                          size={20}
                                        />
                                      </>
                                    )}
                                  </button>
                                </div>
                              </td>
                            </tr>
                            {expandedId === item._id && (
                              <tr>
                                <td colSpan="4" className="py-2 px-4">
                                  <div className="bg-bgBase rounded-10 p-4">
                                    <div className="space-y-4">
                                      {/* Calculate total distance */}
                                      {/* {item.sprints?.length > 0 && (
                                        <p className="text-dark font-medium text-sm text-right">
                                          Total Distance:{" "}
                                          {item.sprints.reduce(
                                            (total, sprint) =>
                                              total +
                                              (parseFloat(sprint.distance) ||
                                                0),
                                            0,
                                          )}
                                          m
                                        </p>
                                      )} */}

                                      {item.sprints?.length > 0 ? (
                                        <div className="space-y-4">
                                          {item.sprints.map(
                                            (sprint, sprintIndex) =>
                                              sprint.type === "Rest" ? (
                                                <div
                                                  key={`rest-${sprintIndex}`}
                                                  className="w-full bg-[#E1E1E1] py-2.5 px-3 rounded-10 text-dark font-normal text-sm"
                                                >
                                                  Rest Segment:&nbsp;
                                                  {sprint.rest_notes ||
                                                    "No notes"}
                                                </div>
                                              ) : (
                                                <div
                                                  key={`sprint-${sprintIndex}`}
                                                  className="bg-white border border-tblBorder shadow rounded-10 space-y-3 p-4"
                                                >
                                                  <div className="flex justify-between gap-5">
                                                    <p></p>

                                                    <div className="flex gap-1">
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.distance}m
                                                      </p>
                                                      <p className="text-dark font-medium text-sm">
                                                        ·
                                                      </p>
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.intensity}%
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="flex flex-wrap gap-x-5 gap-y-2">
                                                    <div className="flex items-center gap-1.5">
                                                      <span className="text-slate100 font-normal text-xs">
                                                        Sets:
                                                      </span>{" "}
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.sets}
                                                      </p>
                                                    </div>
                                                    <div className="flex items-center gap-1.5">
                                                      <span className="text-slate100 font-normal text-xs">
                                                        Reps:
                                                      </span>{" "}
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.reps}
                                                      </p>
                                                    </div>
                                                    <div className="flex items-center gap-1.5">
                                                      <span className="text-slate100 font-normal text-xs">
                                                        Pace:
                                                      </span>{" "}
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.pace}
                                                      </p>
                                                    </div>
                                                    <div className="flex items-center gap-1.5">
                                                      <span className="text-slate100 font-normal text-xs">
                                                        Rest:
                                                      </span>{" "}
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.rest}
                                                      </p>
                                                    </div>
                                                    <div className="flex items-center gap-1.5">
                                                      <span className="text-slate100 font-normal text-xs">
                                                        Exercise:
                                                      </span>{" "}
                                                      <p className="text-dark font-medium text-sm">
                                                        {sprint.exercise_id
                                                          ?.title || "None"}
                                                      </p>
                                                    </div>
                                                  </div>
                                                  <div className="pt-2.5 border-t border-tblBorder flex items-center gap-1.5">
                                                    <div className="text-slate100 font-normal text-xs">
                                                      Notes:{" "}
                                                      {sprint.notes || "-"}
                                                    </div>
                                                  </div>
                                                </div>
                                              ),
                                          )}
                                        </div>
                                      ) : (
                                        <p className="text-sm font-normal text-slate100 text-center italic">
                                          No sprint data found.
                                        </p>
                                      )}
                                    </div>
                                    {item.sprints?.length > 0 ? (
                                      <>
                                        <button
                                          onClick={() => {
                                            setFocusToApply(item);
                                            setShowConfirmModal(true);
                                          }}
                                          className="w-full bg-dark hover:bg-black rounded-10 py-2.5 px-4 flex justify-center items-center gap-2 text-white text-sm font-medium mt-3"
                                        >
                                          Use This{" "}
                                          <MdOutlineKeyboardArrowRight
                                            color="#fff"
                                            size={18}
                                          />
                                        </button>
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </td>
                                <td></td>
                              </tr>
                            )}
                          </React.Fragment>
                        ))}
                    </tbody>
                  </table>
                </div>

                {/* pagination */}
                <div className="flex justify-between items-center py-4">
                  <button
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                    className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                      currentPage === 1 ? "cursor-not-allowed" : "text-black"
                    }`}
                  >
                    <MdKeyboardArrowLeft size={20} /> Previous
                  </button>
                  <span className="text-dark font-inter font-normal text-sm">
                    Page {currentPage} of {totalPages}
                  </span>
                  <button
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                    className={`px-4 py-2 min-w-28 flex justify-center items-center gap-1 rounded-lg text-[#99A1AF] font-inter font-normal text-sm ${
                      currentPage === totalPages
                        ? "cursor-not-allowed"
                        : "text-black"
                    }`}
                  >
                    Next <MdKeyboardArrowRight size={20} />
                  </button>
                </div>
              </div>
            )}
          </div>

          {/*modal for Use a training focus */}
          {showConfirmModal && (
            <div className="fixed inset-0 bg-black bg-opacity-30 flex justify-center z-50">
              <div className="w-full max-w-xl max-h-[99vh] overflow-y-auto">
                <div className="bg-white rounded-lg w-full shadow-lg">
                  <div className="relative py-5 pl-5 md:pl-6 pr-14">
                    <h2 className="text-lg font-semibold mb-4">
                      Confirm Action
                    </h2>
                    <div className="absolute top-4 right-6">
                      <button
                        onClick={() => {
                          setShowConfirmModal(false);
                        }}
                        className="p-2 rounded hover:bg-gray-200 flex justify-center items-center"
                      >
                        <RxCross2 color="#4A5565" size={18} />
                      </button>
                    </div>
                  </div>
                  <div className="p-5 md:p-6 space-y-5 border-y border-tblBorder">
                    <p className="mb-4 text-sm">
                      Do you want to copy this training focus into{" "}
                      <strong>
                        Week {activeWeek}, {activeDay}
                      </strong>
                      ?
                    </p>
                  </div>
                  <div className="p-5 md:p-6 flex justify-end space-x-3">
                    <button
                      onClick={() => setShowConfirmModal(false)}
                      className="px-3 py-1 text-sm border rounded hover:bg-gray-100"
                    >
                      Cancel
                    </button>
                    <button
                      onClick={() => {
                        applyFocusToDay(focusToApply);
                        setShowConfirmModal(false);
                      }}
                      className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                    >
                      Yes, Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export const DraggableSprintItem = ({ sprintIndex, id, sprint }) => {
  const navigate = useNavigate();
  const [dragMode, setDragMode] = useState(true);

  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id,
  });

  const style = transform
    ? {
        transform: `translate3d(${transform.x}px, ${transform.y}px, 0)`,
        transition: "none", // Smooth transition when not dragging
      }
    : undefined;

  return (
    <>
      <div
        ref={setNodeRef}
        {...attributes}
        {...(dragMode ? listeners : {})} // Apply listeners when dragMode is true  // Apply listeners only when dragMode is true
        style={style}
      >
        <div key={sprintIndex} className="">
          {sprint.type === "Rest" ? (
            <div className="w-full bg-[#E1E1E1] py-2.5 px-3 rounded-10 text-dark font-normal text-sm">
              <p>Rest: {sprint.rest_notes || "None"}</p>
            </div>
          ) : (
            <>
              <div className="bg-white border border-tblBorder shadow rounded-10 space-y-3 p-4">
                <div className="flex justify-between gap-5">
                  <p></p>
                  <div className="flex gap-1">
                    <p className="text-dark font-medium text-sm">
                      {sprint.distance}m
                    </p>
                    <p className="text-dark font-medium text-sm">·</p>
                    <p className="text-dark font-medium text-sm">
                      {sprint.intensity}%
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-x-5 gap-y-2">
                  <div className="flex items-center gap-1.5">
                    <span className="text-slate100 font-normal text-xs">
                      Sets:
                    </span>
                    <p className="text-dark font-medium text-sm">
                      {sprint.sets}
                    </p>
                  </div>
                  <div className="flex items-center gap-1.5">
                    <span className="text-slate100 font-normal text-xs">
                      Reps:
                    </span>
                    <p className="text-dark font-medium text-sm">
                      {sprint.reps}
                    </p>
                  </div>
                  {/* <div className="flex items-center gap-1.5">
                  <span className="text-slate100 font-normal text-xs">
                    Distance:
                  </span>
                  <p className="text-dark font-medium text-sm">
                    {sprint.distance}m
                  </p>
                </div> */}
                  <div className="flex items-center gap-1.5">
                    <span className="text-slate100 font-normal text-xs">
                      Pace:
                    </span>
                    <p className="text-dark font-medium text-sm">
                      {sprint.pace}
                    </p>
                  </div>
                  {/* <div className="flex items-center gap-1.5">
                  <span className="text-slate100 font-normal text-xs">
                    Intensity:
                  </span>
                  <p className="text-dark font-medium text-sm">
                    {sprint.intensity}%
                  </p>
                </div> */}
                  <div className="flex items-center gap-1.5">
                    <span className="text-slate100 font-normal text-xs">
                      Rest:
                    </span>
                    <p className="text-dark font-medium text-sm">
                      {sprint.rest}
                    </p>
                  </div>
                </div>
                <div className="pt-2.5 border-t border-tblBorder flex items-center gap-1.5">
                  <p className="text-slate100 font-medium text-sm">
                    Notes: {sprint.notes}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const DroppableSprint = ({ id, children }) => {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });

  return (
    <div
      ref={setNodeRef}
      className={`transition-all duration-150 ease-in-out ${
        isOver ? "bg-gray-100" : ""
      } rounded-md`}
    >
      {children}
    </div>
  );
};
